import { DEFAULT_ENABLED_ANIMAL_TYPES, displayFatteningProfile } from "./animalTypes";

const STORAGE_KEY = "farmAuth";

export function loadFarmAuth() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveFarmAuth(auth) {
  if (!auth) {
    localStorage.removeItem(STORAGE_KEY);
    return;
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(auth));
}

export function clearFarmAuth() {
  localStorage.removeItem(STORAGE_KEY);
}

function normalizeRegistrationType(source) {
  return (
    source?.registerationType ||
    source?.registrationType ||
    null
  );
}

function normalizeEnabledTypes(types) {
  if (Array.isArray(types) && types.length > 0) {
    return types;
  }
  return [...DEFAULT_ENABLED_ANIMAL_TYPES];
}

/** Build farm auth from login user object or profile API response */
export function farmAuthFromApi(source) {
  if (!source) return null;

  const registerationType = normalizeRegistrationType(source);
  const fatteningFarmProfile =
    source.fatteningFarmProfile ||
    (registerationType === "fattening"
      ? displayFatteningProfile(null)
      : undefined);

  return {
    registerationType: registerationType || "breeding",
    fatteningFarmProfile:
      registerationType === "fattening"
        ? displayFatteningProfile(fatteningFarmProfile)
        : undefined,
    enabledAnimalTypes: normalizeEnabledTypes(source.enabledAnimalTypes),
    tenantId: source.tenantId || source.tenant || null,
    tenantCode: source.tenantCode || null,
  };
}

export function mergeFarmAuth(partial) {
  const current = loadFarmAuth() || {};
  const next = {
    ...current,
    ...partial,
    enabledAnimalTypes: normalizeEnabledTypes(
      partial?.enabledAnimalTypes ?? current.enabledAnimalTypes
    ),
  };
  if (next.registerationType !== "fattening") {
    delete next.fatteningFarmProfile;
  }
  saveFarmAuth(next);
  return next;
}
